import React, { ReactElement, useState } from 'react';
import { ImageWrap, ProjectImgContainer, ProjectImgLargerContainer } from './styled';
import { CatalogImage } from 'components';
import Show from 'components/Functional/Show';
import { ThreeBounceLoader } from 'components/LoadingIndicator';
import { CATALOG_IMAGE_RESPONSIVE_SIZES } from 'constants/images';
import { useSplitTreatment } from '../../../hooks/splits/useSplitTreatment';
import { SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1, SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1_COOKIE } from 'constants/split';

interface CartImageProps {
  projectImgUrl?: string;
  productImgUrl: string;
  alt: string;
  children?: ReactElement;
  onLoad?: () => void;
  thumbnailLoading?: boolean;
  handleItemClick: () => void;
}

const CartImage = ({
  projectImgUrl,
  productImgUrl,
  alt,
  children,
  onLoad = () => {},
  thumbnailLoading,
  handleItemClick
}: CartImageProps): React.JSX.Element => {
  const [projectThumbError, setProjectThumbError] = useState<boolean>(false);

  const { treatmentStatus: showCartPreview1Split } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1,
    SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1_COOKIE
  );

  return (
    <ImageWrap onClick={handleItemClick}>
      {children}
      <CatalogImage src={productImgUrl} alt={alt} widths={CATALOG_IMAGE_RESPONSIVE_SIZES} lazyLoad={false}/>
      <Show when={!projectThumbError}>
        {showCartPreview1Split ? (
          <ProjectImgLargerContainer>
            <Show when={thumbnailLoading}>
              <ThreeBounceLoader size={5} color='black'/>
            </Show>
            <Show when={!!projectImgUrl}>
              <img src={projectImgUrl} alt="Project Preview" onLoad={onLoad} onError={() => setProjectThumbError(true)}/>
            </Show>
          </ProjectImgLargerContainer>
        ) : (
          <ProjectImgContainer>
            <Show when={thumbnailLoading}>
              <ThreeBounceLoader size={5} color='black'/>
            </Show>
            <Show when={!!projectImgUrl}>
              <img src={projectImgUrl} alt="Project Preview" onLoad={onLoad} onError={() => setProjectThumbError(true)}/>
            </Show>
          </ProjectImgContainer>
        )}
      </Show>
    </ImageWrap>
  );
};

export default CartImage;
